import Modal from "../Modal"
import { createUseStyles } from 'react-jss'
import { useEffect, useState } from "react"
import { OpenShiftRecipient, PayRun } from "../../redux/types"
import { useTranslation } from "react-i18next"
import OpenShiftRecipientList from "./OpenShiftRecipientList"

interface Props {
    visible: boolean
    recipients: OpenShiftRecipient[]
    onCloseClick: () => void
}

const OpenShiftRecipientModal = ({visible, recipients, onCloseClick}: Props) => {
    const styles = useStyles()
    const { t } = useTranslation(['common']);

    const [pageIndex, setPageIndex] = useState<number>(1)

    useEffect(() => {
        setPageIndex(1)
    }, [recipients])

    const handleOnClose = () => {
        onCloseClick()
    }

    return (
        <Modal
            size="lg"
            title={t('recipients', {ns: 'common'})}
            visible={visible}
            okButtonTitle={t('close', {ns: 'common'})}
            hideCancelButton={true}
            onHide={handleOnClose}
            onOkClick={handleOnClose}
            onCancelClick={handleOnClose}
        >
            <div className={styles.container}>
               <OpenShiftRecipientList
                    pageIndex={pageIndex}
                    pageSize={15}
                    recipients={recipients}
                    onPageChange={(pageIndex: number) => setPageIndex(pageIndex)}
               />
            </div>
        </Modal>
    )
}

export default OpenShiftRecipientModal

const useStyles = createUseStyles({
    container: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
    },
})
